if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('a[href*="choicehotels.com"]').each(function() {
        var $this = $(this);       
        var _href = $this.attr("href");
        if (_href.indexOf('?') >= 0) {
            $this.attr("href", _href + "&mc=frtmxxpx");
        }else{
            $this.attr("href", _href + "?mc=frtmxxpx");
        }
    });

    $('.sym-slides').slick({
        accessibility: false
    });
    setTimeout(function(){ 
        $('a[href*="/privacy-policy"]').each(function(){ 
            $(this).attr("href", "/choice-hotels-privacy-policy"); 
        });
    }, 2000);

    /** Scroll Hotel Amenity Fee & Other Anchors Adjustment **/
        
    function scrollDown() {
        const elementOffset = document.querySelector('#hotel-amenity-fee').offsetTop;        
        const additionalOffset = 400;
        window.scrollTo({
            top: elementOffset + additionalOffset,
            behavior: 'smooth'
        });
    }
    
    document.addEventListener('DOMContentLoaded', function() {
        const sectionId = location.hash.substring(1);
        const section = document.getElementById(sectionId);
        
        if (sectionId === 'hotel-amenity-fee') {
            scrollDown();
        } else if (section) {
            setTimeout(() => {
                window.scrollTo({
                    top: section.offsetTop - 200,
                    behavior: 'smooth'
                });
            }, 1000);
        }
    });
    document.querySelectorAll('.form-module-wrapper').forEach(form => {
        if (form.id.includes('contactus') || form.id.includes('contact')) {
            form.classList.add('animate');
        }
    })
})();